import { useCallback, useEffect, useState } from 'react';
import { usePrivilege } from '../../components/priviledge/PriviledgeProvider';
import { CategoryService } from '../../services/category/categoryService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage category fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de categorias.
----------------------------------------------------------------------------------------*/

const useCategories = () => {

    const { userCan } = usePrivilege();
    const [data, setData] = useState<any[]>([]);

    const fetchCategories = useCallback(async () => {
        try {
            if (!userCan('list', 'category')) return;   
            const service = new CategoryService();
            const response = await service.listForSelect({ limit: 999999 });
            const fetchedData = response.getResponseData();

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; color: string; }) => ({
                    value: data.id,
                    label: data.name,
                    color: data.color,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching categories:', error);
        }
    }, []);

    useEffect(() => {
        fetchCategories();
    }, []);

    const getCategoriesList = () => {
        return data;
    };

    return { fetchCategories, getCategoriesList };    
}

export default useCategories;
